/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Arreglo: el botón "Caja" quedaba muerto (Zapiet <-> app de Términos y Condiciones)
 *
 * Zapiet invoca window.customCheckoutValidation({checkoutMethod}, callback) y sólo continúa
 * hacia el checkout cuando esa función llama al callback. La app de Términos registra ahí una
 * función que espera un evento del DOM y descarta la llamada por isTrusted, sin llamar nunca al
 * callback: la cola de Zapiet queda colgada en su addon "custom" y el botón no hace nada.
 *
 * Este shim envuelve lo que registre la app de Términos y cumple el contrato de Zapiet.
 */
(function () {
  // Normalmente custom.js corre antes que la app de Términos, pero si ya registró algo lo conservamos.
  var registered = window.customCheckoutValidation;

  function termsAccepted() {
    var boxes = document.querySelectorAll('.rterms-checkbox');

    // La app de Términos no está presente en esta página: no hay nada que validar.
    if (!boxes.length) {
      return true;
    }

    for (var i = 0; i < boxes.length; i++) {
      // El checkbox que vive dentro del modal es una copia, no cuenta como aceptación.
      if (boxes[i].closest && boxes[i].closest('.rterms-modal')) {
        continue;
      }

      if (boxes[i].checked) {
        return true;
      }
    }

    return false;
  }

  function alertMessage() {
    var configured = window.rterms && window.rterms.metafield && window.rterms.metafield.alert_message;
    return configured || 'Debes aceptar los términos y condiciones de compra para continuar.';
  }

  Object.defineProperty(window, 'customCheckoutValidation', {
    configurable: true,

    get: function () {
      if (typeof registered !== 'function') {
        return registered;
      }

      return function (context, done) {
        // Llamada con la firma original de la app de Términos (un evento del DOM): la dejamos pasar.
        if (typeof done !== 'function') {
          return registered.apply(this, arguments);
        }

        // Llamada desde Zapiet: hay que responder por el callback, siempre.
        if (termsAccepted()) {
          return done(true);
        }

        window.alert(alertMessage());
        return done(false);
      };
    },

    set: function (value) {
      registered = value;
    }
  });
})();